export default "__VITE_ASSET__640b8948__"